import { domain } from "../auth/domain";

const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Access token not found.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `JWT ${token}`,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: "An unknown error occurred." }));
    throw new Error(errorData.detail || `Request failed with status ${response.status}`);
  }
  return response.json();
};

export const fetchGroupExpenses = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await fetch(`${domain}expenses/group-expenses/?${query}`, {
    headers: getAuthHeaders(),
  });
  return handleResponse(response);
};

export const createGroupExpense = async (expenseData) => {
  const response = await fetch(`${domain}expenses/group-expenses/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(expenseData),
  });
  return handleResponse(response);
};

export const approveGroupExpense = async (expenseId, role) => {
  let action = null;
  if (role === "Katibu") action = "secretary_approve";
  if (role === "Muhasibu") action = "accountant_approve";
  if (!action) throw new Error("You are not authorized to approve this expense.");

  const response = await fetch(`${domain}expenses/group-expenses/${expenseId}/${action}/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({}),
  });
  return handleResponse(response);
};

export const rejectGroupExpense = async (expenseId, reason) => {
  const response = await fetch(`${domain}expenses/group-expenses/${expenseId}/reject/`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ reason }),
  });
  return handleResponse(response);
};
